import { SearchComponent } from '../Search'

import './index.css'

const NavigationBarComponent = () => {
    return (
        <div className="c-NavigationBar">
            <h1><span>FYC Deals</span></h1>

            <div className="navigationBar-search">
                <SearchComponent />
            </div>
        </div>
    )
}

export { NavigationBarComponent }
